import { Link, useMatch, useResolvedPath } from "react-router-dom";



function BtnLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
  
    return (
      <div>
        <Link
          style={{ textDecoration : "none" , padding: match?"8px" : "8px 16px", color : match? "yellow" : "white", backgroundColor: "rgb(132, 10, 208)" ,borderRadius : "5px", fontWeight: "bolder" }
        
        
        
        }
          to={to}
          {...props}
        >
          {children}
        </Link>
       
      </div>
    );
  }
  export default BtnLink